module.exports = {
    DEFAULT_REVIEWS_SORT: 'relevant_by_work_sample'
};
